function AlcoholScheduleCommand() {
    "use script";
    this.__type = 'AlcoholScheduleCommand:www.veritracks.com';
    this.Id = -1;
    this.EnrolleeId = null;
    this.EnrolleeTimeZone = '';
}
if (typeof exports !== 'undefined') {
    module.exports = AlcoholScheduleCommand;
}